import React, { useState } from "react";
import { Layout, Menu, Breadcrumb, Card,  } from "antd";
import {
  UserOutlined,
  LaptopOutlined,
  NotificationOutlined
} from "@ant-design/icons";


import { Row, Col, Container, Alert } from "reactstrap";
import { Form, Input, Button } from "antd";
import * as firebase from 'firebase'

import { Auth, Storage, Firestore } from "../../config/firebase";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Dropdown } from 'semantic-ui-react'


const { SubMenu } = Menu;
const { Header, Content, Footer, Sider } = Layout;

export default function NewUpdates() {
  const [Title, setTitle] = useState("");
  const [Highlight, setHighlight] = useState("");
  const [Deadline, setDeadline] = useState(new Date());
  const [Funds, setFunds] = useState("");
  const [Focus_Area, setFocus] = useState("");
  const [Type, setType] = useState("");
  const [Apply, setwebapply] = useState("");
  const [messageRes, setMessage] = useState('')
  const [error, setError] = useState('')



  const onFinish = values => {
      const data = {
        Title,  
        Highlight, 
        Deadline, 
        Funds,
        Focus_Area,  
        Type,
        Apply,
        createdAt: Date.now()
      }
    console.log("Received values of form: ", data);

    if(!data) {
        
      setError("Fill Form Correctly")
      setMessage('')
    }

    else {
        Firestore.collection("updates")
        .add(data)
        .then(res => {
          console.log("successfully added to firebase")
          setMessage("Updates successfully added")
        })
        .catch(error => {
          console.log(error);
          throw error;
        });
    }
  };

  const handleOnChange = (e, data) => {
    console.log(data.value);
    setType(data.value)
    console.log('Type', Type);
 }

const initialValues = {
   Title: "",
    Highlight: "",
    Deadline: "",
    Funds: "",
    Focus: "",
    Type: "",
    Apply: "",
};


const handleChange = (tags) => {
    setType(tags)
}

const options = [
    { key: 'venture fund', text: 'venture fund', value: 'venture fund'},
    { key: 'Accelerator', text: 'Accelerator', value: 'Accelerator'},
    { key: 'Crypto Fund', text: 'Crypto Fund', value: 'Crypto Fund'},
    { key: 'Grants', text: 'Grants', value: 'Grants'},
    { key: 'Bounty', text: 'Bounty', value: 'Bounty'},
    { key: 'Hackathon', text: 'Hackathon', value: 'Hackathon'},
 ]
 
  return (
    <>
      <Container className="">
        <Card>
          New Grant
          <hr />
           {messageRes === '' ? '' : <Alert>{messageRes}</Alert>}
           {error === '' ? '' : <Alert color={"danger"}>{error}</Alert>}
           
          <Form
            name="normal_login"
            className="login-form"
            initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            <Row>
              <Col md={6} lg={6} sm={12}>
                <label>Title</label>
                <Form.Item
                  name="Title"
                  rules={[
                    { required: true, message: "Please input your Title" }
                  ]}
                >
                  <Input allowClear 
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    placeholder="Title" value={Title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </Form.Item>
              </Col>

              <Col md={6} lg={6} sm={12}>
                <label>Highlight</label>
                <Form.Item
                  name="Highlight"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Highlight line"
                    }
                  ]}
                >
                  <Input allowClear 
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    placeholder="Highlight" value={Highlight}
                    onChange={e => setHighlight(e.target.value)}
                  />
                </Form.Item>
              </Col>

              <Col md={6} lg={6} sm={12}>
                <label>Deadline</label>
                <Form.Item
                  name="Deadline"
                  rules={[
                    { required: true, message: "Please input your Deadline" }
                  ]}
                >
                 <Input type='date'
                  style={{width: '100%'}}
                    onChange={e => setDeadline(e.target.value)}
                  />
                   
                </Form.Item>
              </Col>

              <Col md={6} lg={6} sm={12}>
                <label>Funds</label>
                <Form.Item
                  name="Funds"
                  rules={[
                    { required: true, message: "Please input your Funds" }
                  ]}
                >
                  <Input allowClear 
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    placeholder="Focus Area" value={Funds}
                    onChange={e => setFunds(e.target.value)}
                  />
                </Form.Item>
              </Col>

              <Col md={6} lg={6} sm={12}>
                <label>Focus Area</label>
                <Form.Item
                  name="Focus Area"
                  rules={[
                    { required: true, message: "Please input your Focus Area" }
                  ]}
                >
                  <Input allowClear 
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    placeholder="Focus Area" value={Focus_Area}
                    onChange={e => setFocus(e.target.value)}
                  />
                </Form.Item>
              </Col>

              <Col md={6} lg={6} sm={12}>
               <label>Type</label>   
              <Dropdown placeholder='Type' onChange={handleOnChange} fluid multiple selection options={options} />

              </Col>

              <Col md={6} lg={6} sm={12}>
                <label>Website Link</label>
                <Form.Item
                  name="Link"
                  rules={[
                    {
                      required: true,
                      message: "Please input your website Link"
                    }
                  ]}
                >
                  <Input allowClear 
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    placeholder="Website Link" value={Apply}
                    onChange={e => setwebapply(e.target.value)}
                  />
                </Form.Item>
              </Col>


              <Col md={12} lg={12}>
                <hr />
              </Col>

              <Col md={12} lg={12} sm={12} className="text-right">
                <Button  htmlType="submit">Save</Button>
              </Col>
            </Row>
          </Form>
        </Card>
      </Container>
    </>
  );
}